import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  TEST_PURCHASE_CLEAR,
  TEST_PURCHASE_COMPLETE_EVIDENCE,
  TEST_PURCHASE_FETCH_LINK_INFO_REQUEST,
} from '../../../actions/actionTypes';

const completeEvidence = fetchReducerGenerator(
  [TEST_PURCHASE_CLEAR, TEST_PURCHASE_FETCH_LINK_INFO_REQUEST],
  TEST_PURCHASE_COMPLETE_EVIDENCE
);

export default completeEvidence;
